import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material';
import { CuiToasterService, CuiToastOptions } from '@cisco-ngx/cui-components';

@Injectable()
export class NotificationsService {

  constructor(
    private snackBar: MatSnackBar,
    private toasts: CuiToasterService
  ) { }

  public simpleSnackBar(message: string, actionLabel: string = '', duration: number = 3000): MatSnackBarRef<SimpleSnackBar> {
    let ref: MatSnackBarRef<SimpleSnackBar> = this.snackBar.open(message, actionLabel, { duration: duration });
    return ref;
  }

  public toast(severity: string, title: string, message: string, padding: string): CuiToastOptions {
    return this.toasts.addToast(severity, title, message, padding);
  }

}
